import React from 'react';

const Harvest = () => {
  return <div>Harvest</div>;
};

export default Harvest;
